import React, { useState } from "react";
import "./CheckboxGroupStyles.scss";

import { FieldArray, ErrorMessage, useFormikContext } from "formik";
import { ModalCentered } from "components/generic/ModalCentered";
import { Modal } from "react-bootstrap";
import { WorkType } from "generated/types/types";

export type Checkbox<V> = {
    value: V;
    label: string;
    subLabel?: string;
    disabled?: boolean;
    message?: string;
    url?: string;
};

export type Props = {
    name: string;
    className?: string;
    checkboxes: Checkbox<string>[];
    selectedValues: string[] | null;
    containerClassName?: string;
};

export const CheckboxGroup: React.FC<Props> = (props: Props) => {
    const [showModal, setShowModal] = useState<boolean>(false);
    const [message, setMessage] = useState<string | null>(null);
    const [url, setUrl] = useState<string | null>(null);
    const { setFieldValue } = useFormikContext();

    return (
        <div className={props.containerClassName ?? ""}>
            <FieldArray
                name={props.name}
                render={arrayHelpers => (
                    <>
                        {props.checkboxes.map(option => {
                            const optionUrl = option.url;
                            return (
                                <div key={option.value} className={`checkbox-input ${props.className ?? ""} ${option.disabled ? "checkbox-disabled" : ""}`}>
                                    <input
                                        id={option.value}
                                        name={props.name}
                                        type="checkbox"
                                        disabled={option.disabled}
                                        value={option.value}
                                        checked={props.selectedValues?.includes(option.value)}
                                        onChange={e => {
                                            if (e.target.checked) {
                                                arrayHelpers.push(option.value);
                                                if (option.message) {
                                                    setUrl(optionUrl ?? null);
                                                    setMessage(option.message);
                                                    setShowModal(true);
                                                }
                                            } else {
                                                const id = (props.selectedValues || []).indexOf(option.value);
                                                if (id > -1) {
                                                    arrayHelpers.remove(id);
                                                }
                                            }
                                            if (!e.target.checked && option.value === WorkType.RepairOther) {
                                                setFieldValue("safetyRecall", false);
                                            }
                                        }}
                                    />
                                    <label htmlFor={option.value}>
                                        {option.label}
                                        <br />
                                        {optionUrl === null || optionUrl === undefined || optionUrl.trim() === "" ? (
                                            option.subLabel ?? ""
                                        ) : (
                                            <a
                                                href={["http://", "https://"].some(prefix => optionUrl.startsWith(prefix)) ? optionUrl : "https://" + optionUrl}
                                                target="_blank"
                                                rel="noreferrer"
                                            >
                                                {option.subLabel ?? ""}
                                            </a>
                                        )}
                                    </label>
                                </div>
                            );
                        })}
                    </>
                )}
            />
            <ErrorMessage name={props.name} component="div" className="error-msg" />
            <ModalCentered size="sm" show={showModal} onHide={() => setShowModal(false)}>
                <div className="custom-dialog">
                    <Modal.Header closeButton />
                    {url === null || url === undefined || url.trim() === "" ? (
                        message
                    ) : (
                        <a href={url} target="_blank" rel="noreferrer">
                            {message}
                        </a>
                    )}
                </div>
            </ModalCentered>
        </div>
    );
};
